import React from 'react'
import classes from './HpHeading.module.css'
import hpVector from '../../../assets/img/Hp-Vector.png'

const HpHeading = props => {
  return (
    <div className='text-center'>
    <h2 className={classes.heading}>{props.heading}</h2>
    <img className={classes['heading-vector']} src={hpVector} alt=''/>
    <h2 className={classes['sub-heading']}>{props.subHeading}</h2>
    </div>
  )
}


export default HpHeading